export default {
  report() {
    console.log(window)
    return {
      window_size: {
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight,
        outerWidth: window.outerWidth,
        outerHeight: window.outerHeight
      },
      screen_size: {
        width: window.screen.width,
        height: window.screen.height,
        availLeft: window.screen.availLeft,
        availTop: window.screen.availTop
      },
      scroll_offset: {
        x: window.scrollX,
        y: window.scrollY,
        height: document.documentElement.scrollHeight
      },
      orientation: window.screen.orientation
        ? window.screen.orientation.type
        : 'N/A'
    }
  }
}
